export enum KeyboardSelector {
	NEGATIVE_TAB_INDEX = '[tabindex="-1"]'
}
